import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const ManageDrivers = Loadable(lazy(() => import("./DriversList")));
const AddDriver = Loadable(lazy(() => import("./AddDriver")));
const EditDriver = Loadable(lazy(() => import("./EditDriver")));
const DriverProfileGeneral = Loadable(lazy(() => import("./DriverProfileGeneral")));

const manageDriversRoutes = [
    { path: "/drivers/list", element: <ManageDrivers/> },
    { path: '/drivers/add-driver', element: <AddDriver /> },
    { path: '/drivers/edit-driver', element: <EditDriver /> },
    { path: "/drivers/driver", element: <DriverProfileGeneral/> }
];

export default manageDriversRoutes;